export default "__VITE_ASSET__CHClxD72__"